__webpack_require__.p = "https://board-staging.zabran.id/";